import P from "@babel/runtime/helpers/esm/slicedToArray";
import t from "react";
import { createPortal as v } from "react-dom";
import g, { register as C } from "@semcore/core";
import c from "@semcore/utils/lib/canUseDOM";
import { getNodeByRef as x } from "@semcore/utils/lib/ref";
var m = C.get("portal-context", /* @__PURE__ */ t.createContext(c() ? document.body : null));
function d(e) {
  var n = e.Children, o = e.disablePortal, f = e.ignorePortalsStacking, r = e.onMount, a = t.useContext(m), s = t.useState(null), l = P(s, 2), i = l[0], u = l[1];
  return t.useEffect(function() {
    if (!o) {
      if (r == null || r(!0), f) {
        u(c() ? document.body : null);
        return;
      }
      u(x(a));
    }
  }, [a, o, r]), o ? /* @__PURE__ */ t.createElement(n, null) : i ? /* @__PURE__ */ v(/* @__PURE__ */ t.createElement(n, null), i) : null;
}
d.displayName = "Portal";
var R = m.Provider;
const E = g(d);
export {
  R as PortalProvider,
  E as default
};
